var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._l((this.sentences),function(sentence,index){return [(sentence.startsWith('link!'))?[_c('a',{key:index,on:{"click":function($event){$event.stopPropagation();_vm.link(_vm.linkContents(sentence, 1))}}},[_vm._v(_vm._s(_vm.linkContents(sentence, 0)))])]:_c('span',{key:index,domProps:{"innerHTML":_vm._s(sentence)}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }